// extracted by mini-css-extract-plugin
module.exports = {"button":"text-font-picker_button__ZYt7X","fontDropdownContainer":"text-font-picker_fontDropdownContainer__8oM_Y"};